<template>
  <div>
    <main-header-info :navInfoItems="schema.navInfoItems" />
    <v-container>
      <v-row class="mx-auto my-16">
        <v-col>
          <v-card class="white--text mx-auto my-auto" persistent width="550" height="380">
            <v-card-title primary-title>
              <div>
                <div class="text-h5 primary2--text text--darken-3 mt-5">
                  Ingresa el código de verificación
                </div>
                <span class="subtitle-1 secundary--text"
                  >Recibiste un número de 6 dígitos por SMS.</span
                >
              </div>
            </v-card-title>
            <v-card-actions>
              <v-row>
                <v-col cols="12">
                  <div>
                    <div class="ma-auto position-relative" style="max-width: 300px">
                      <v-otp-input
                        v-model="otp"
                        length="6"
                        :disabled="loading"
                        @finish="onFinish"
                      ></v-otp-input>
                      <v-overlay absolute :value="loading">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                      </v-overlay>
                    </div>

                    <span class="d-flex justify-center text-caption black--text mt-7">
                      {{ text }}
                    </span>
                  </div>
                </v-col>
                <v-col cols="12" class="d-flex justify-center">
                  <v-btn
                    class="secundary2 white--text mt-7 text-capitalize"
                    @click="reSendCode"
                    disabled
                    v-if="timerActive === true"
                  >
                    Reenviar código
                    <span class="text-lowercase">({{ timerCount }} seg.)</span>
                  </v-btn>
                  <v-btn
                    class="secundary2 white--text mt-7 text-capitalize"
                    @click="reSendCode"
                    v-else
                  >
                    Reenviar código
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-snack-bar :snackbar="snackbar" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderInfo from '@/components/includes/MainHeaderInfo.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';

export default {
  name: 'ProOTPPage',
  components: {
    MainHeaderInfo,
    VSnackBar,
  },
  data() {
    return {
      loading: false,
      otp: '',
      text: '',
      timerActive: false,
      timerCount: 0,
    };
  },
  mounted() {
    this.loadSchema();
  },
  computed: {
    ...mapGetters('proOTPPage', ['schema', 'status']),
    ...mapGetters('usersCodeVerif', ['usersCodeVerif', 'usersCodeVerifGen']),
    ...mapGetters('notifications', ['snackbar']),
  },
  watch: {
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--;
          }, 1000);
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions('proOTPPage', ['loadSchema']),
    ...mapActions('usersCodeVerif', ['getUsersCodeVerif', 'getUsersCodeVerifGen']),
    ...mapActions('notifications', ['triggerSnackbar']),

    async onFinish() {
      this.loading = true;
      const type = 'Pro';

      let model = {};
      model.otp = this.otp;
      model.type = type;

      await this.$store.dispatch('usersCodeVerif/getUsersCodeVerif', { model });
      const usersCodeVerif = this.usersCodeVerif;

      if (usersCodeVerif === true) {
        setTimeout(() => {
          this.loading = false;
          this.text = 'Código de verificación es correcto';
        }, 1500);
        this.snackbar.visible = false;
        this.snackbar.visible = true;
        this.snackbar.content = this.schema.snackOk;
        setTimeout(() => {
          this.snackbar.visible = false;
          this.$router.push({ name: 'login' });
        }, 3000);
      } else if (usersCodeVerif === false) {
        setTimeout(() => {
          this.loading = false;
          this.text = 'Código de verificación es incorrecto';
        }, 1500);
      }
      this.otp = '';
      this.text = ' ';
    },
    async reSendCode() {
      this.timerCount = 30;
      this.timerActive = true;
      setTimeout(() => {
        this.timerActive = false;
        this.timerCount = 0;
      }, 30000);

      const type = 'Pro';
      let model = {};
      model.type = type;

      await this.$store.dispatch('usersCodeVerif/getUsersCodeVerifGen', model);
      const usersCodeVerifGen = this.usersCodeVerifGen;

      if (!usersCodeVerifGen) {
        setTimeout(() => {
          this.loading = false;
          this.text = 'Hubo un error al enviar el código; inténtelo nuevamente.';
          this.snackbar = true;
        }, 3500);
      }

      if (usersCodeVerifGen === true) {
        setTimeout(() => {
          this.loading = false;
          this.text = 'Código de verificación reenviado';
          this.snackbar = true;
        }, 3500);
        this.snackbar.visible = false;
        this.snackbar.visible = true;
        this.snackbar.content = 'Código de verificación reenviado';
        setTimeout(() => {
          this.snackbar.visible = false;
        }, 2000);
      }
      this.otp = '';
      this.text = ' ';
    },
  },
};
</script>

<style>
#form-base-complete .key-subgroups-content {
  background-color: #faf3e9;
  padding: 1rem;
}

#form-base-complete .key-subgroups-tasks {
  background-color: #e2eaf5;
  padding: 1rem;
}

@media print {
  html * {
    position: fixed;
    top: 0;
    bottom: 0;
    visibility: hidden;
  }

  .key-subgroups-content textarea {
    visibility: visible;
    left: 0;
    top: 0;
    bottom: 0;
  }

  .key-subgroups-content textarea * {
    visibility: visible;
  }
}
</style>
